import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronRight } from "@fortawesome/pro-regular-svg-icons"
import { Card, Img, Content, StyledContent, StyledLink } from "./styles"

const Highlight = ({ data, mobileOnly, desktopOnly }) => {
  if (!data) {
    return null
  }

  return (
    <Card
      alert={!!data.alert}
      href={data.url}
      target={data.url_in_new_window ? "_blank" : ""}
      mobileOnly={mobileOnly}
      desktopOnly={desktopOnly}
    >
      {data.thumbnail && <Img src={data.thumbnail} />}

      <Content>
        <StyledContent componentStyles={{ generic: { variant: "content" } }}>{data.content}</StyledContent>

        {!!data.url && (
          <StyledLink>
            <span>Learn more</span>
            <FontAwesomeIcon icon={faChevronRight} size="1x" />
          </StyledLink>
        )}
      </Content>
    </Card>
  )
}

export default Highlight
